export default "__VITE_ASSET__BPcD8pxB__"